import React, { useEffect, useState } from "react";

import { gql, useLazyQuery, LazyQueryHookOptions } from "@apollo/client";
import { Spin } from "antd";
import Table from "../DataOverview/Table";
import { CSVLink } from "react-csv";

import DateRangePicker from "rsuite/DateRangePicker";
import moment from "moment";

interface Patient {
    firstName: string;
    lastName: string;
}

interface Hl7Logging {
  hl7Logging: {
    _id: string;
    eventCreatedAt: string;
    hl7ReceivedAt: string;
    admissionType: string;
    messageType: string;
    attendingPhysicianNPI: string;
    patient: string;
    patientData: Patient;
  }[];
}

enum MessageType {
  A01 = "A01",
  A04 = "A04",
  A11 = "A11",
}

const DATA_HL7LOGGING = gql`
  query ($from: String!, $to: String!, $patientName: String!, $admissionType: String!, $messageType: MessageType!, $sortInput: HL7LoggingSort!) {
    hl7Logging(
      patientName: $patientName
      admissionType: $admissionType
      eventDatesRange: { from: $from, to: $to }
      messageType: $messageType
      sort: $sortInput
    ) {
      _id
      eventCreatedAt
      hl7ReceivedAt
      admissionType
      messageType
      attendingPhysicianNPI
      patientData {
        firstName,
        lastName,
      }

    }
  }
`;

export default function HL7Logging() {

  const [displayData, setDisplayData] = useState<any>([]);
  const [sortInput, setSortInput] = useState<object>({eventCreatedAt: -1})
  const [messageType, setMessageType] = useState<string>(MessageType.A04);
  const [dateRange, setDateRange] = useState(["", ""]);
  const [patientName, setPatientName] = useState<string>("");
  const [admissionType, setAdmissionType] = useState<string>("");
  const [clearLodaing, setClearLodaing] = useState(false);

  const [getHL7Loggin, { loading, error, data }] = useLazyQuery<Hl7Logging>(
    DATA_HL7LOGGING,

    {
      fetchPolicy: "network-only",
      onCompleted: (completeData) => {
        console.log(data);
        const tempArr = [];
        tempArr.push([
          "Event date and time",
          "Message received on",
          "Patient Name",
          "Message type",
          "Admission Type",
          "Physician NPI",
        ]);

        completeData.hl7Logging.forEach((value) => {
          tempArr.push([
            value.eventCreatedAt,
            moment
                .utc(value.hl7ReceivedAt)
                .tz("America/New_York")
                .format("YYYY-MM-DDTHH:mm:ss.SSSSSS"),
            value.patientData?(`${value.patientData.lastName}, ${value.patientData.firstName}`):"Not found",
            value.messageType,
            value.admissionType,
            value.attendingPhysicianNPI
          ]);
        });

        setDisplayData(tempArr);
        setClearLodaing(false);
      },
    }
  );

  useEffect(() => {
    getDefaultData();
  }, []);

  const getDefaultData = () => {
    getHL7Loggin({
      variables: {
        patientName: "",
        admissionType: "",
        from: "",
        to: "",
        messageType: MessageType.A04,
        sortInput: {eventCreatedAt: -1}
      },
    });
  };

  const getData = () => {
    getHL7Loggin({
      variables: {
        patientName: patientName,
        admissionType: admissionType,
        from: dateRange[0],
        to: dateRange[1],
        messageType: messageType,
        sortInput: sortInput
      },
    });
  };

  const handleDrop = (message: any) => {
    getHL7Loggin({
      variables: {
        patientName: patientName,
        admissionType: admissionType,
        from: dateRange[0],
        to: dateRange[1],
        messageType: message,
        sortInput: sortInput
      },
    });
  }

  const handleDate = (dateRange: any) => {
    getHL7Loggin({
      variables: {
        patientName: patientName,
        admissionType: admissionType,
        from: dateRange[0],
        to: dateRange[1],
        messageType: messageType,
        sortInput: sortInput
      },
    });
  }

  const handlePatientName = (patientName: string) => {
    getHL7Loggin({
      variables: {
        patientName: patientName,
        admissionType: admissionType,
        from: dateRange[0],
        to: dateRange[1],
        messageType: messageType,
        sortInput: sortInput
      },
    });
  }

  const clearForm = () => {
    setPatientName("");
    setAdmissionType("");
    setDateRange(["", ""]);
    setMessageType(MessageType.A04);
    setSortInput({eventCreatedAt: -1})
    setOrder("none")
    setClearLodaing(true);
    getDefaultData();
  };

  const handleKeyPress = (event: any) => {
    if (event.key === "Enter") {
      getData();
    }
  };

   const [sortField, setSortField] = useState("");
   const [order, setOrder] = useState("asc");
   const handleSorting = (index: any) => {
     const sortOrder =
     index === sortField && order === "asc" ? "desc" : "asc";
     const sortHeader = ["eventCreatedAt", "hl7ReceivedAt", "patient", "messageType", "admissionType", "attendingPhysicianNPI", ][index]
     const int_sort = (sortOrder === "asc" ? 1 : -1)
     const sortInput = {[sortHeader]: int_sort}
     console.log("hl7", sortField, sortOrder)
     setSortField(index);
     setOrder(sortOrder);
     getHL7Loggin({
       variables: {
         patientName: patientName,
         admissionType: admissionType,
         from: dateRange[0] || "",
         to: dateRange[1] || "",
         messageType: messageType,
         sortInput: sortInput
       },
     });
    };

  return (
    <div className="container">
      <div className="flex-between ">
        <h4 className="content-title">HL7 logging</h4>
      </div>
      <div className="flex-between search-filter-box">
        <div className="flex">
          <div>
            <span className="search-filter-label">Select event date</span>
            {!clearLodaing ? (
              <DateRangePicker
                format="MM/dd/yyyy"
                onChange={(value) => {
                  //console.log(value);
                  if (value) {
                    setDateRange([
                      moment(value[0]).format("YYYY/MM/DD"),
                      moment(value[1]).format("YYYY/MM/DD"),
                    ]);
                    handleDate([
                      moment(value[0]).format("YYYY/MM/DD"),
                      moment(value[1]).format("YYYY/MM/DD"),
                    ]);
                  }
                }}
                onClean={(value) => {
                  clearForm();
                }}
              />
            ) : null}
          </div>
          <div className="searchButtons">
            <span className="search-filter-label">Message source</span>
            <select
              name=""
              id=""
              className="search-filter-input"
              style={{ width: "150px" }}
              value={messageType}
              onChange={(e) => {
                setMessageType(e.target.value)
                handleDrop(e.target.value)
                }
              }
              onKeyPress={handleKeyPress}
            >
              <option value="A01">A01</option>
              <option value="A04">A04</option>
              {/* <option value="A11">A11</option> */}
            </select>
          </div>
            <div className="flex">
              <div>
                <span className="search-filter-label">
                  Search by Patient Name
                </span>
                <input
                  type="text"
                  className="search-filter-input"
                  value={patientName}
                  onChange={(e) => {
                      setPatientName(e.target.value)
                      handlePatientName(e.target.value)
                  }}
                  onKeyPress={handleKeyPress}
                />
              </div>
              <div>
                <span className="search-filter-label">Search by Admission Type</span>
                <input
                  type="text"
                  className="search-filter-input"
                  value={admissionType}
                  onChange={(e) => setAdmissionType(e.target.value)}
                  onKeyPress={handleKeyPress}
                />
              </div>
            </div>
        </div>

        <div>
          <button
            className="export-button clear"
            onClick={() => {
              clearForm();
            }}
          >
            Clear
          </button>
          {/* <button
            className="export-button"
            onClick={() => {
              getData();
            }}
          >
            Search
          </button> */}
        </div>
      </div>
      {loading || data === undefined ? (
        <>
          <Spin />
        </>
      ) : (
        <>
          <div className="exportuploadbuttonposition">
            <CSVLink
              data={displayData}
              filename={`HL7Logging_${messageType}_${moment().format(
                "MM/DD/YYYY_HH:mm:ssss"
              )}.csv`}
              className="export-button"
            >
              Export
            </CSVLink>
          </div>

          <Table
            headers={[
              "ID",
              "Event date and time",
              "Message recieved on",
              "Patient Name",
              "Message type",
              "Admission Type",
              "Physician NPI",
            ]}
            headersSortBool={[
              true,
              true,
              true,
              true,
              false,
              true,
              true
            ]}
            data={data?.hl7Logging.map((value) => [
              value._id,
              // value.eventCreatedAt,
              moment
                .utc(value.eventCreatedAt)
                .format("MM/DD/yyyy HH:mm:ss"),
              // moment(value.eventCreatedAt).format("MM/DD/yyyy HH:mm:ss"),
              // moment(value.hl7ReceivedAt).format("MM/DD/yyyy HH:mm:ss"),
              // value.hl7ReceivedAt,
              moment
                .utc(value.hl7ReceivedAt)
                .tz("America/New_York")
                .format("MM/DD/yyyy HH:mm:ss"),
              value.patientData?(`${value.patientData.lastName}, ${value.patientData.firstName}`):"<Not found>",
              value.messageType,
              value.admissionType,
              value.attendingPhysicianNPI,
            ])}
            handleSorting={handleSorting}
            order={order}
            field={sortField}

          />
        </>
      )}
    </div>
  );
}
